import { assignRep, getTags, getTicketHistory, getWaitingTickets, sendResponseTicket } from "../../api/ticket";
import { TABLE_API } from "../../api/table";

const table = {
    namespaced: true,
    state: {
        tables: [],
    },
    getters: {},
    mutations: {
        SET_TABLES: (state, payload) => {
            state.tables = payload;
        },
    },
    actions: {
        async fetchCustomerTables({ commit }, queries) {
            const tables = await TABLE_API.listTables();
            commit("SET_TABLES", tables);
            return tables;
        },
    },
};

export default table;
